// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failed-container {
  width: 100vw;
}

.failed-container .MuiPaper-root {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  max-width: 58.24vw !important;
  max-height: 32.47vw !important;
}

.thankyou-container .MuiPaper-root {
  width: 100%;
  height: 100% !important;
  margin: 0 !important;
  max-width: 58.24vw !important;
  max-height: 32.47vw !important;
}

.product-limit-container .MuiPaper-root {
  width: 58.24vw;
  height: 100% !important;
  margin: 0 !important;
  max-width: 58.24vw !important;
  max-height: 32.47vw !important;
}

.failed-inner-container {
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(238, 58, 36, 0.8), rgba(151, 71, 255, 0.8));
}
.failed-inner-container .close-dialog {
  position: relative;
  right: 1.11vw;
  top: 1.11vw;
}

.failed-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  position: relative;
  top: 22%;
}

.product-limit-wrapper {
  border-radius: 3px;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  background: #FFFFFF;
  padding: 1.11vw;
  height: 100%;
}
.product-limit-wrapper .close-dialog {
  position: relative;
  right: 1.11vw;
  top: 0.2775vw;
}

.close-dialog {
  position: relative;
  right: 1.11vw;
  top: 0.8325vw;
}

.failed-content,
.product-limit-content,
.thankyou-content {
  text-align: center;
}

.close-dialog {
  text-align: end;
}

.failed-text h2 {
  color: #fff;
  font-size: 2.08125vw;
  font-weight: 400;
  line-height: 2.08125vw;
  margin: 1.25vw 0;
}

.failed-text p {
  color: #fff;
  font-size: 1.05vw;
  font-weight: 400;
  line-height: 1.25vw;
  margin-bottom: 2.25vw;
}

.product-limit-text {
  color: #3A3A3A;
}

.product-limit-text h2 {
  font-weight: 400;
  line-height: 2.08vw;
  margin: 1.25vw 0;
  font-size: 2.08125vw;
}

.thankyou-text h3 {
  font-weight: 400;
  line-height: 2.08vw;
  font-size: 1.65vw;
  margin: 1.25vw 0;
}

.product-limit-text p {
  font-size: 1.05vw;
  font-weight: 500;
  line-height: 1.25vw;
  margin: 1.25vw 0;
}

.thankyou-text p {
  font-size: 1.05vw;
  font-weight: 500;
  line-height: 1.25vw;
}

.thankyou-text p span a {
  color: #EE3A24;
}

.contact-us {
  background-color: #EE3A24;
  border-radius: 3px;
  padding: 1.11vw 4.44vw;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 0.91vw;
  line-height: 1.25vw;
  font-weight: 500;
}

.thankyou-content {
  position: relative;
  margin: 0 3.98vw;
}

.thankyou-text {
  width: 100%;
  position: absolute;
  top: 2.22vw;
  transform: translate(0, 95%);
}

.product-limit-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 22%;
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/FailedToRetrieve.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,6BAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,uBAAA;EACA,oBAAA;EACA,6BAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,6BAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,uFAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AACJ;;AAGA;EACE,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AADF;;AAYA;EAEE,kBAAA;EACA,+DAAA;EACA,mBAAA;EACA,eAAA;EAEA,YAAA;AAXF;AAaE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;AAXJ;;AAwBE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;AArBJ;;AA6BA;;;EAGE,kBAAA;AA1BF;;AA6BA;EACE,eAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA1BF;;AA6BA;EACE,cAAA;AA1BF;;AA8BA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AA3BF;;AA+BA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AA5BF;;AAgCA;EACE,cAAA;AA7BF;;AAoCA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,kBAAA;EAEA,gBAAA;AAlCF;;AAsCA;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACD,4BAAA;AApCD;;AA4CA;EACE,WAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AA1CF","sourcesContent":[".failed-container {\n  width: 100vw;\n}\n\n.failed-container .MuiPaper-root {\n  width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n  max-width: 58.24vw !important;\n  max-height: 32.47vw !important;\n}\n\n.thankyou-container .MuiPaper-root {\n  width: 100%;\n  height: 100% !important;\n  margin: 0 !important;\n  max-width: 58.24vw !important;\n  max-height: 32.47vw !important;\n}\n\n.product-limit-container .MuiPaper-root {\n  width: 58.24vw;\n  height: 100% !important;\n  margin: 0 !important;\n  max-width: 58.24vw !important;\n  max-height: 32.47vw !important;\n}\n\n.failed-inner-container {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to bottom, #EE3A24CC, #9747FFCC);\n\n  .close-dialog {\n    position: relative;\n    right: 1.11vw;\n    top: 1.11vw;\n  }\n}\n\n.failed-wrapper {\n  width: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: auto;\n  position: relative;\n  top: 22%;\n}\n\n// .failed-wrapper{\n\n\n//  border-radius: 3px;\n//   box-shadow: 0 0 0 3px #BEBEBE40;\n//   padding: 1rem ;\n\n// }\n.product-limit-wrapper {\n\n  border-radius: 3px;\n  box-shadow: 0px 4px 7.4px 0px #BEBEBE40;\n  background: #FFFFFF;\n  padding: 1.11vw;\n\n  height: 100%;\n\n  .close-dialog {\n    position: relative;\n    right: 1.11vw;\n    top: 0.2775vw;\n  }\n}\n\n// .thankyou-wrapper {\n\n//   border-radius: 3px;\n//   box-shadow: 0px 4px 7.4px 0px #BEBEBE40;\n//   background: #FFFFFF;\n//   padding: 1.11vw;\n//   // width: 100%;\n//   height: 100%;\n\n  .close-dialog {\n    position: relative;\n    right: 1.11vw;\n    top: 0.8325vw;\n  }\n// }\n\n//  .failed-content{\n//   position: relative;\n//   transform: translate(50%,50%);\n//  } \n.failed-content,\n.product-limit-content,\n.thankyou-content {\n  text-align: center;\n}\n\n.close-dialog {\n  text-align: end;\n}\n\n.failed-text h2 {\n  color: #fff;\n  font-size: 2.08125vw;\n  font-weight: 400;\n  line-height: 2.08125vw;\n  margin: 1.25vw 0;\n}\n\n.failed-text p {\n  color: #fff;\n  font-size: 1.05vw;\n  font-weight: 400;\n  line-height: 1.25vw;\n  margin-bottom: 2.25vw;\n}\n\n.product-limit-text {\n  color: #3A3A3A;\n\n}\n\n.product-limit-text h2 {\n  font-weight: 400;\n  line-height: 2.08vw;\n  margin: 1.25vw 0;\n  font-size: 2.08125vw;\n \n}\n\n.thankyou-text h3 {\n  font-weight: 400;\n  line-height: 2.08vw;\n  font-size: 1.65vw;\n  margin: 1.25vw 0;\n}\n\n.product-limit-text p {\n  font-size: 1.05vw;\n  font-weight: 500;\n  line-height: 1.25vw;\n  margin: 1.25vw 0;\n}\n\n.thankyou-text p {\n  font-size: 1.05vw;\n  font-weight: 500;\n  line-height: 1.25vw;\n\n}\n\n.thankyou-text p span a {\n  color: #EE3A24;\n}\n\n// .thankyou-text{\n//   position: relative;\n//   transform: translate(0px, 127%);\n// }\n.contact-us {\n  background-color: #EE3A24;\n  border-radius: 3px;\n  padding: 1.11vw 4.44vw;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.91vw;\n  line-height: 1.25vw;\n  font-weight: 500;\n}\n\n.thankyou-content {\n  position: relative;\n  // width: 100%;\n  margin: 0 3.98vw;\n  \n}\n\n.thankyou-text {\n\n  width: 100%;\n  position: absolute;\n  top: 2.22vw;\n transform: translate(0 , 95%);\n}\n\n// @media only screen and (max-width: 414px) {\n//   .contact-us{\n//     padding: 0.75rem 1rem;\n//   }\n// }\n.product-limit-content {\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  top: 22%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
